import './order.less';
import React from 'react';
import PropTypes from 'prop-types';

import Order from '../../../shared/order-list/main';

const propTypes = {
	toggleSwitchToOrder: PropTypes.func,
	intl: PropTypes.func,
	orderSortedEnd: PropTypes.func,
	saveOrderSort: PropTypes.func,
	shouldShowSaveOrderBtn: PropTypes.bool,
	lists: PropTypes.object
};

const SortableOrder = ({
	toggleSwitchToOrder,
	intl,
	data,
	orderSortedEnd,
	saveOrderSort,
	shouldShowSaveOrderBtn
}) => (
	<div className="table-container table-container--projector sortable-offers-wrap">
		<div className="table-container--projector__header">
			<div className="sortable-offers-wrap__header">
				<p className="sortable-offers-wrap__header-name font-roboto-medium">{intl('Offer')}</p>
				<a
					href="javascript:;"
					className="order-close"
					onClick={toggleSwitchToOrder}>
					{intl('Return to list of offers')}
				</a>
				{ shouldShowSaveOrderBtn && (
					<p
						className="order-action-btn order-action-btn--order"
						onClick={() => {
							confirm(intl('Change offer sort ?')) && saveOrderSort();
						}}>
						<span>{intl('Save order')}</span>
					</p>
				) }
			</div>
		</div>
		<div className="table-container--projector__body">
			<div className="table-container--projector__body-content">
				<Order onSortEnd={orderSortedEnd}>
					{ data.map((row, index) => (
						<Order.Item
							key={index}
							id={JSON.stringify({ location_id: row.location_id, offer_id: row.offer_id })}
						>
							<div className="sortable-offers-wrap__item">
								<span className="sortable-offers-wrap__item-drag" />
								<div className="sortable-offers-wrap__item-title">
									<span className="sortable-offers-wrap__item-title__text">
										{row.title} {` (${row.country_name})`}
									</span>
								</div>
							</div>
						</Order.Item>
					)) }
				</Order>
			</div>
		</div>
	</div>
);

SortableOrder.propTypes = propTypes;
export default SortableOrder;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/table-additional/order.js